import MessageType from '../../../enums/MessageType';
import Translation from '../../lang/Translation';
import {getSettings} from '../../selectors/selectors';
import {overwriteDeliveryAddress} from '../address-actions';
import {resetDeliveryOptions} from '../deliveryOptionActions';
import {getOrderSummaryForCountry} from '../orderSummaryActions';
import {setPageMessage} from '../pageMessageActions';

export default (addressId, country) => (dispatch, getState) => {
  dispatch(overwriteDeliveryAddress(addressId, {country}));
  dispatch(resetDeliveryOptions());
  dispatch(getOrderSummaryForCountry({value: country}))
    .then(() => {
      if (getSettings(getState())?.show_import_warning) {
        const deliveryCountrySpecificMessage = Translation.getText(
          `errors.deliveryCountrySpecificMessage.${country}`,
        );
        
        if (deliveryCountrySpecificMessage) {
          dispatch(setPageMessage(deliveryCountrySpecificMessage, MessageType.INFO));
        }
      }
    });
};
